import { normalizeAppPath } from "@/pages/gm-routes";

const CREATOR_SCENE_PATH = /^\/creator\/s\/([^/]+)$/;

export function parseCreatorSceneFromPath(pathname: string): string | null {
  const path = normalizeAppPath(pathname);
  const match = CREATOR_SCENE_PATH.exec(path);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}

export function isCreatorAppPath(pathname: string): boolean {
  const path = normalizeAppPath(pathname);
  return path === "/creator" || path.startsWith("/creator/");
}

export function creatorSceneEditorPath(sceneId: string): string {
  return `/creator/s/${encodeURIComponent(sceneId)}`;
}
